export const PriorityTracks = {
    PRIORITY_RULE_ENABLED: 'helpdesk-priority-rules-enabled ',
    PRIORITY_RULE_DISABLED: 'helpdesk-priority-rules-disabled ',
    PRIORITY_RULE_ADDED: 'helpdesk-priority-rule-added ',
    PRIORITY_RULE_DELETED: 'helpdesk-priority-rule-deleted ',
    PRIORITY_RULE_EDITED: 'helpdesk-priority-rule-edited ',
    PRIORITY_CONDITION_ADDED: 'helpdesk-priority-rule-condition-added ',
    PRIORITY_CONDITION_DELETED: 'helpdesk-priority-rule-condition-deleted ',
    PRIORITY_CONDITION_UPDATED: 'helpdesk-priority-rule-condition-updated ',
};
